import React, { Component } from 'react';
import defaults from 'legacy/src/components/content/editor/types/defaultContents';
import { AP_COMPUTER_SCIENCE_PRINCIPLES } from 'chameleon-src/constants/subjects';
import Button from 'chameleon/ui-stack/ui/base/button';

import './ItemSelector.scss';

class ItemSelector extends Component {
  constructor(props) {
    super(props);
    this.onAdd = this.onAdd.bind(this);
  }

  render() {
    const { params = {} } = this.props;
    const isCSPSubject =
      parseInt(params.subject, 10) === AP_COMPUTER_SCIENCE_PRINCIPLES;
    const freeResponseTypes = ['free_response', 'questions/free_response'];

    return (
      <div className="ItemSelector">
        <h4>Type:</h4>
        <div className="grid grid-cols-1 gap-x-2 gap-y-6">
          {this.props.types.map((type) => (
            <Button isSuccess key={type} onClick={() => this.onAdd(type)}>
              {isCSPSubject && freeResponseTypes.includes(type)
                ? 'Performance Task'
                : NAMES[type] || type}
            </Button>
          ))}
        </div>
      </div>
    );
  }

  onAdd(type) {
    this.props.onAdd(type, { type, ...defaults[type] });
  }
}
export default ItemSelector;

export const NAMES = {
  'media/rich_text': 'Text',
  'media/image': 'Image',
  'media/math': 'Equation',
  'media/audio': 'Audio',
  'questions/multiple_choice': 'Multiple Choice',
  multiple_choice: 'Multiple Choice',
  'questions/free_response': 'Free Response',
  free_response: 'Free Response',
  'composite/quiz': 'Quiz',
  'composite/question_set': 'Question Set',
};
